import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 29341 27946"
    {...props}
  >
    <path
      d="M14671 419c0 10679-3024 12875-14252 10354 11228 2521 12383 6075 5444 16754 6939-10679 10676-10679 17616 0-6940-10679-5785-14233 5443-16754-11228 2521-14251 325-14251-10354z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 838.324,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
